import { render, staticRenderFns } from "./StorageQuota.vue?vue&type=template&id=f08a8710&"
import script from "./StorageQuota.vue?vue&type=script&lang=js&"
export * from "./StorageQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports